module.exports = __webpack_public_path__ + "img/s (4).9703608f.png";